var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.084,
    y: -0.225,
    fill: "none",
    width: 100,
    height: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.508,22.048H16.324c-2.746,0-4.974,2.228-4.974,4.973v45.506c0,2.746,2.228,4.975,4.974,4.975h67.184 c2.746,0,4.973-2.229,4.973-4.975V27.021C88.48,24.276,86.254,22.048,83.508,22.048z M77.6,27.34l-27.97,28.615L22.157,27.34H77.6z  M16.324,28.443l20.849,21.718L16.324,70.43V28.443z M21.298,72.527l19.317-18.779l7.205,7.5c0.466,0.486,1.109,0.76,1.782,0.766 c0.673,0,1.318-0.27,1.791-0.748l7.533-7.709l19.166,18.971H21.298z M83.508,70.891L62.402,50.002l21.105-21.589V70.891z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonEmail);
export default __webpack_public_path__ + "static/media/button-email.e868dcb4.svg";
export { ForwardRef as ReactComponent };